module.exports = __webpack_public_path__ + "static/media/S3N6-2.bd897180.svg";